import { useState } from "react";
import { Container, Typography, Box, Pagination } from "@mui/material";
import styles from "./TermsAndConditions.module.scss";
import useScrollToHash from "../../helpers/useScrollToHash";

const termsContent = [
  [
    {
      title: "1. License:",
      text: "This document is an electronic record as defined by the Information Technology Act, 2000 (“IT Act, 2000”) and related statutes. It is generated by a computer system and does not require any physical or digital signatures.",
    },
    {
      title: "", // No title for list items
      text: "• In compliance with Rule 3 (1) of the Information Technology (Intermediaries Guidelines) Rules, 2011, which requires the publication of rules and regulations, privacy policy, and terms of use for accessing or using the website at www.biddingkaro.in (the 'Platform'), we hereby publish the following terms of use.",
    },
    {
      title: "", // No title for list items
      text: "• The Platform, including the related mobile site, mobile application, and web portal, is owned and operated by Bidding Genie Private Limited (“Bidding Karo”), a company incorporated under the Companies Act, 1956, with its registered office at First Floor, Shri Ram Market, Sector 86, Tigaon Road, Faridabad, Haryana 121002.",
    },
    {
      title: "", // No title for list items
      text: "• Throughout these Terms of Use, “you” and “your” refer to any natural or legal person who has registered to become a user of the Platform using computer systems. The term “user” collectively refers to sellers, buyers, and visitors on the Platform, while “we,” “us,” and “our” refer to Bidding Karo.",
    },
  ],
  [
    {
      title: "2. Enrolment Eligibility:",
      text: "To use the Platform, you must complete the registration process for one or more of the Services offered. Use of the Services is restricted to parties that can lawfully enter into contracts under applicable law. As part of the registration process, you must provide us with your legal name, address, phone number, email address, applicable tax registration details, and any other information we may require. Any personal data you provide to us will be handled in accordance with the Bidding Genie Privacy Policy.",
    },
    {
      title: "", // No title for list items
      text: "• Bidding Karo reserves the right to terminate or remove your registration and/or deny you access to the Platform if we become aware that you are not seriously participating in bid whether you are Buyer or Supplier or if you violate any of the Terms of Use . If you register on behalf of a business entity, you represent and warrant that you are authorized by the business entity to accept the Terms of Use on its behalf and that you have the authority to bind the business entity to the Terms of Use. Using platform means you have accepted the terms and conditions and other policies on this platform and you are aware that the bidding Karo does not own responsibility for any losses due to decisions taken on the basis of the information provide here as all the information on the platform are provided by the users only and we doesn’t own any responsibility..",
    },
  ],
  [
    {
      title: "3. Services Offered:",
      text: "Services Offered: Bidding Karo provides a comprehensive suite of services designed to streamline and optimize the sourcing process using system programming or Artificial Intelligence (AI) wherever required. Our AI-based Sourcing Application (AISA) offers the following services:",
    },
    {
      title: "", // No title for list items
      text: "• Vendor Search and Listing: - Vendor Identification: Upon entering your sourcing requirements, our system will generate a list of potential vendors within India that might match your product specifications.",
    },
    {
      title: "", // No title for list items
      text: "• Price Verification and Quotation: - Price Verification: The system automatically provides data of previous bids done by users specific for similar products to provide a benchmark.",
    },
    {
      title: "", // No title for list items
      text: "• Quotation Requests: Users can request quotes from multiple vendors through the platform, streamlining the quotation process.",
    },
    {
      title: "", // No title for list items
      text: "Computer System Powered Negotiation:  - Automated Negotiation: Users can input their best sourcing price into the application, and then the system will negotiate with vendors to achieve the best possible price.",
    },
    {
      title: "", // No title for list items
      text: "•  Real-Time Updates: The application provides real-time updates on the negotiation status and final pricing offers from vendors. Terms of the Live biddings are on the Portal and using the live bids assumed that users have read the terms and Conditions of the bidding. To make system user friendly, Bidding Karo provides live bids status on 10 seconds gap. Users have to make their systems updated as per the Bidding Karo Portal and their networks intact. Still if there is any problem to users during the Live bidding, Bidding Karo doesn’t own any responsibility related to this. All the decisions related to bidding allotment are solely of the Bidders. Bidder may allot the Bid to L1 user or any other participant. Bidding Karo can’t ask the bidder to allot to L1 only. All the decisions are purely of the bidder. Bidding Karo is only the platform provided for negotiation. Participants are allowed to put the price against the specific products maximum upto 3 times. On bidding the price in the live bid by the previous vendor and thereafter no other vendor has put the price in the live bid for that product till next 5 mins then the previous Participant will be declared as L1. Likewise when all products requirement closed for the specific bids then after 15 Mins that specific bids will be closed from the Portal.",
    },
    {
      title: "", // No title for list items
      text: "Vendor Selection:   - Optimal Vendor Recommendation: Based on price, quality, and other relevant factors, the  application recommends the best vendor for your needs.",
    },
    {
      title: "", // No title for list items
      text: "•  Decision Support: Users can review detailed analytics and comparison reports to make informed decisions.",
    },
    {
      title: "", // No title for list items
      text: "Letter of Intent Management: - Automated LOI: Once a vendor is selected, the AI system generates and sends the Letter Intent to the chosen vendor.",
    },
    {
      title: "", // No title for list items
      text: "•  Order Tracking: Once Letter of Intent is provided from the Bidding Karo, then Role of the Bidding Karo comes to an end to that specific bidding. Bidding Karo does not monitor whether formal Purchase order was issued, Delivery Schedule, actual Quality of products delivered, Payment against the delivery etc. Users can rate to buyers or vendors on their users experience so that other users must be aware of any experience.   ",
    },
    {
      title: "", // No title for list items
      text: "Quality Assurance:  - Quality Check Procedures: The Bidding Karo assists users to specify the quality requirements to vendors and can ask for the samples or visit requirement before commercial bidding. Bidding Karo never ensures for any quality on the delivered product. All quality assurance processes must be done by the buyers and vendors independently.",
    },
    {
      title: "", // No title for list items
      text: "• Approval Workflows: Users can set up approval workflows where sourced materials are only accepted after passing quality checks by the Bidding Karo.   ",
    },
    {
      title: "", // No title for list items
      text: "Please note that Bidding Karo does not warrant the accuracy, completeness, reliability, correctness, or error-free nature of Product descriptions or other content on the Platform and assumes no liability in this regard.",
    },
  ],
  [
    {
      title: "4. Service Fee Payments:",
      text: "Registration for using the Platform is free of charge, and browsing and registering on the Platform does not incur any fees. However, Bidding Karo reserves the right to modify its fee policy at its sole discretion, including introducing new services and amending or introducing fees for existing services. Any changes to the fee policy will be posted on the Platform and will become effective immediately upon posting. All fees will be quoted in Indian Rupees (INR) and must be paid to Bidding Karo in compliance with applicable laws.",
    },
    {
      title: "",
      text: "• Payment made by the bidder will be considered only once it got credited in the Bidding Karo Account or any other payment interface. Till payment not credited, users may not be allowed to use the Portal for specific requirement.",
    },
    {
      title: "",
      text: "• Once Payment done then the users can’t modify, change or cancel the bid. If so required then the amount will not be refunded and users has to pay again for creation of the bid.",
    },
    {
      title: "",
      text: "• Editing Bids- A bid can be edited only if no supplier has been invited to participate in that bid.",
    },
    {
      title: "",
      text: "• Once a supplier is invited, the bid becomes non-editable, regardless of the time elapsed.",
    },
    {
      title: "",
      text: "• Amending Bids - The buyer can make amendments of the bid at any time before the bid goes live but key items like Reserve price, quantity etc can be amended at time. New bid to be created after paying the fee if new key bid items are required to be amended.",
    },
    {
      title: "",
      text: "• Once the bid goes live, no further changes can be made.",
    },
    {
      title: "",
      text: "• Cancelling Bids - The buyer can cancel the bid at any time before the bid goes live. Once the bid goes live, cancellation is not permitted.",
    },
    {
      title: "",
      text: "• Inviting Suppliers - The buyer can invite suppliers only if the bid is active and the bid date has been set. Suppliers can only be invited before the bid goes live. Once the bid is live, no new invitations can be sent.",
    },
    {
      title: "",
      text: "• Supplier Response to Bid Invitation - The supplier can accept or decline the bid invitation at any time before the bid goes live. Once the bid goes live, the supplier can no longer respond to the invitation.",
    },
    {
      title: "",
      text: "• Supplier Participation Approval - In certain bid types, suppliers must receive approval before participating in live bidding. Approval is based on criteria set by the buyer, such as sample submission for quality checks and others. Supplier Participation is on the wish of the bidder. Bidding Karo can’t ask the bidder to allow participation of any Participator in the bid.",
    },
    {
      title: "",
      text: "• Compliance with Legal and Platform Policies - All users must comply with applicable laws and the platform's policies. Any violation may result in account suspension or legal action.",
    },
    {
      title: "",
      text: "• Product Cancellation Rules - If no products are awarded within 7 days after the bid ends, all products in the bid will be automatically canceled. If a specific product remains unawarded after the bid, only that product will be canceled after 7 days.",
    },
    {
      title: "",
      text: "• Supplier Revocation - Buyers can revoke a supplier from the bid at any time before the bid goes live.",
    },
    {
      title: "",
      text: "• No Refund - Once a bid is placed and payment is processed on the Bidding Karo platform, no refund will be issued.",
    },
    {
      title: "",
      text: "• Last-Moment Bids Will Not Be Captured - Suppliers are advised that the bids placed at the last moment may not be captured in the live bid process. The bid will only be confirmed if it meets the necessary conditions within the specified time frame. Decision to accept or reject the bids is solely the decision of the bidder.",
    },
    {
      title: "",
      text: "• Role-Based System Access - The Bidding Karo platform operates on a role-based system, where specific tasks and actions are assigned to users based on their role. Each role has distinct permissions, and users can only perform actions that align with their assigned role.",
    },
    {
      title: "",
      text: "• Supplier Participation - A supplier can only enter or participate in a bid if their live bid invitation has been accepted by the bidder.",
    },
    {
      title: "",
      text: "• Bid Submission Limit - Suppliers have only 3 chances to place the bid amount for each product.",
    },
    {
      title: "",
      text: "• Bid Amount Rules - The bid amount placed by the supplier must be lower than the current price or Reserved Price. The decrement amount must be followed by the supplier as set by the buyer. Suppliers must adhere to the minimum decrement amount defined by the buyer.",
    },
    {
      title: "",
      text: "• Awarding Bids and Letter of Intent (LOI) - After the conclusion of a live bid, the platform will generate and display the Letter of Intent (LOI) for the awarded suppliers. The buyer has full discretion in awarding the bid and can select any participating supplier based on specific criteria, not just the L1 supplier. Only the awarded suppliers will be eligible to view and receive the LOI. The LOI will be automatically generated by the system and made available to the relevant parties.",
    },
    {
      title: "",
      text: "• Time-Based Bidding Restrictions - The idle timeout for a product's bid is 5 minutes. If no price updates are received within this time, the bid for that product closes automatically, and no further bids can be placed. To avoid any last time confusion, participants are required to bid the price atleast 20 secs before the closure of 5 mins.",
    },
    {
      title: "",
      text: "• Confidentiality of Bidding Information - Bidders must not disclose bid details, pricing, or negotiations to third parties. Any breach of confidentiality may lead to penalties or disqualification from future bids.",
    },
    {
      title: "",
      text: "• Eligibility Criteria for Bidding - Only verified companies with completed profiles can participate in bidding. Incomplete or unverified accounts will not have access to bid placement.",
    },
    {
      title: "",
      text: "• Upon a user’s request to close their account, the account will be placed on hold for 90 days to facilitate the completion of any outstanding transactions. After confirmation of closure and the absence of any outstanding payments, the user’s account will be deactivated. Certain information will be retained by Bidding Karo, including the registered mobile number, registered email ID, GSTIN, and other transaction-related information, for audit purposes and to prevent fraudulent activity in the future.",
    },
  ],
  [
    {
      title: "5. Platform for Transaction and Communication:",
      text: "Bidding Karo only provides a platform for communication between buyers and sellers and is not responsible for any non-performance or breach of contract between them. The commercial/contractual terms are solely between the buyers and sellers, and Bidding Karo does not advise, control, or involve itself in any way in the offering or acceptance of such terms. Bidding Karo does not make any representations or warranties about the products or services being sold, and the contract for sale of any product or service is strictly between the seller and the buyer. Additionally, pricing on any product(s) may be incorrect due to technical issues or typographical errors, and in such cases, the seller may cancel the order.",
    },
  ],
  [
    {
      title: "6. Indemnification:",
      text: "Indemnification: - By using Bidding Karo's services, you agree to indemnify, defend, and hold harmless Bidding Karo, its affiliates, officers, directors, employees, agents, and licensors (collectively, the (Indemnified Parties) from and against all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) that the Indemnified Parties may incur because of or arising from:",
    },
    {
      title: "",
      text: "• Your Use of the Services: Any use or misuse of the Bidding Karo platform by you or anyone using your account.",
    },
    {
      title: "",
      text: "• Violation of Terms: Your violation of these Terms and Conditions or any applicable law or regulation.",
    },
    {
      title: "",
      text: "• Breach of Representations and Warranties: Any breach of your representations and warranties set forth in these Terms and Conditions.",
    },
    {
      title: "",
      text: "• Third-Party Claims: Any third-party claims, actions, or demands arising from or related to your use of the Bidding Karo platform, including but not limited to:\n\n• Intellectual property infringement claims\n\n• Claims related to the quality, safety, or legality of products or services sourced through the platform\n\n• Disputes between B and a vendor or other third party\n\n• Claim for Payment through Buyer",
    },
    {
      title: "",
      text: "• Data and Security: Any claim or liability arising from your failure to maintain the security and confidentiality of your account information or your breach of any data protection obligations.",
    },
  ],
  [
    {
      title: "7. System Driven Process: -",
      text: " Our System-driven application offers a comprehensive and streamlined approach to vendor sourcing, ensuring an unbiased and efficient process. Below is a detailed overview of the various stages involved:",
    },
    {
      title: " • Requirement Analysis",
      text: " The process begins with the user entering their specific requirements into the system. This includes details such as the type of product or service needed, quantity, quality standards, budget constraints, and delivery timelines. The  application uses natural language processing (NLP) to understand these requirements.",
    },
    {
      title: " • Vendor Identification",
      text: "Leveraging a vast database of vendors within India, the System application lists potential vendors that might match the user’s criteria. The system evaluates vendors based on various parameters including product offerings, geographical location, past performance, and ratings given by other users. Advanced algorithms are employed to ensure the selection process is unbiased and comprehensive to the extent possible..",
    },
    {
      title: " • Initial Vendor Contact",
      text: " Once the relevant vendors are identified, Bidder initiate the process. It sends out automated system requests to vendor for acceptance of bid participation on specified date. ",
    },
    {
      title: " • Live Bidding  Process",
      text: " Live Bidding Process will be initiated on specified date and all participants need to put their best prices against the another vendor price. Product wise Lowest price vendor will be declared L1.",
    },
    {
      title: " • Vendor Recommendation",
      text: "After negotiations are complete, the system application advises the user on the best vendor based on a combination of negotiated prices and other relevant factors. The recommendation is accompanied by a detailed analysis and comparison of the top vendor options, enabling the user to make an informed decision.",
    },
    {
      title: " • User Approval and Purchase Order",
      text: " The process begins with the user entering their specific requirements into the system. This includes details such as the type of product or service needed, quantity, quality standards, budget constraints, and delivery timelines. The  application uses natural language processing (NLP) to understand these requirements.",
    },
    {
      title: " • Vendor Identification",
      text: "Upon the user's approval of the recommended vendor or any other vendor other than L1, the system automatically generates and sends a Letter of Intent  (LOI) to the selected vendor. The LOI  includes all necessary details such as product specifications, agreed prices, delivery schedules, and payment terms. This LOI is  system generated and contains the general terms and Conditions and will be followed by Official PO if required by Bidder and selected vendor  adheres to the user’s requirements and compliance standards.",
    },
    {
      title: " • Quality Assurance and Delivery Monitoring",
      text: " System Facilitates the Quality approval process before Commercial bidding and Quality 	qualified vendors can participate in the commercial bidding. All decisions related to quality 	approval or rejection are solely of buyer or vendors, Bidding Karo has no role in this. Bidding 	Karo neither ensures that actual quality of goods or services delivered will be same as sample 	quality. Bidding Karo only facilities for the information available on the portal provided by 	different users. Information used by any users are solely decisions of the user of that 	information, We didn’t recommend any users for any decisions taken based on the data on 	the Bidding Karo.",
    },
    {
      title: " • Rating and Feedback",
      text: " Bidding Karo also facilities for the Feed back  by the users based on their experience so that other users can use the information and accordingly on the basis of the information system shows the ratings of the users. Bidding Karo has no role and control over the rating and doesn’t own any responsilbilities for any ratings on the Portal.",
    },
    {
      title: " • Continuous Improvement",
      text: "The AI application continuously learns from each transaction, refining its algorithms to improve future sourcing processes. This involves updating vendor profiles, adjusting negotiation tactics, and enhancing recommendation accuracy based on historical data and user feedback.",
    },
    {
      title: "8. Confidentiality: - ",
      text: "All Data on the Platforms are Public Data and Bidding Karo does not responsible for a Confidentiality of the same.",
    },
    {
      title: "9. Limitation of Liability: -",
      text: "Bidding Karo strives to provide accurate and reliable sourcing recommendations. However, the final decision on vendor selection and quality assurance lies with the user. Bidding Karo is not liable for any direct, indirect, incidental, or consequential damages arising from the use of our services.",
    },
  ],
  [
    {
      title: "10. User Conduct and Rules on the Platform -",
      text: "By using the Platform, you agree to adhere strictly to the following binding principles:",
    },
    {
      title: "",
      text: "• Bidding Karo provides an online bidding platform and does not directly participate in transactions between buyers and suppliers. The platform acts as an intermediary facilitating communication and transactions.",
    },
    {
      title: "",
      text: "• The platform is designed for business-to-business (B2B) transactions. Only registered companies, businesses, and verified entities can participate in bidding.",
    },
    {
      title: "",
      text: "• The buyer holds the discretion to select the supplier and award the bid. Bidding Karo does not interfere with the selection process.",
    },
    {
      title: "",
      text: "• Bidding Karo does not guarantee the quality, delivery, or performance of the products or services offered by suppliers.",
    },
    {
      title: "",
      text: "• The bid creation and participation process must comply with the terms and conditions set forth by Bidding Karo. Any violation may lead to disqualification or suspension from the platform.",
    },
    {
      title: "",
      text: "• Bidding Karo reserves the right to suspend or terminate any user account if fraudulent activity, misrepresentation, or non-compliance with policies is detected.",
    },
    {
      title: "",
      text: "• The platform does not provide payment guarantees. Payments must be settled directly between buyers and suppliers through the agreed-upon payment method.",
    },
    {
      title: "",
      text: "• Bidding Karo is not liable for disputes arising from the bidding process, payment issues, or contractual obligations between buyers and suppliers.",
    },
    {
      title: "",
      text: "• The bidding data, user details, and transaction records are stored securely. However, Bidding Karo does not take responsibility for any data breaches due to third-party cyber-attacks.",
    },
    {
      title: "",
      text: "• By using Bidding Karo, users acknowledge and agree to the platform’s terms, conditions, and policies. Continued use of the platform signifies acceptance of these terms.",
    },
    {
      title: "",
      text: "Failure to comply with these principles may result in the cancellation of an order, termination of your account, or other appropriate action by the company.",
    },
  ],
  [
    {
      title: "11. Contents Posted on Platform",
      text: "Bidding Karo serves as an intermediary for third-party user-generated content, including but not limited to text, graphics, user interfaces, visual interfaces, photographs, trademarks, logos, sounds, music, and artwork (collectively referred to as ‘Content’). Bidding Karo does not exercise control over such Content. By submitting Content to Bidding Karo, you grant us worldwide, perpetual, and transferable rights to the Content. The Content will become our property, and we may use any or all elements of the Content for any purpose, including but not limited to promotional and advertising purposes, consistent with our Privacy Policy and applicable law. We reserve the right to create derivative works that may include the Content provided by you, and we may use such Content in any media, now known or hereafter devised.",
    },
    {
      title: "12. About the Account:",
      text: "The Bidding Karo Wallet may be  provided to you by Bidding Genie Private Limited and it enables you to add a rupee value to your Bidding Karo Wallet for use exclusively on the Bidding Karo Platform. The value associated with the Bidding Karo Wallet is not insured or guaranteed by any entity or individual. The rupee value you load onto your Bidding Karo Wallet is strictly for prepayment purposes for Bidding only, unless otherwise indicated. You can load your Bidding Karo Wallet on the Bidding Karo Platform using the available payment options.",
    },
    {
      title: "13. Bidding Genie",
      text: "Reserves the right to decline any Bidding Karo Wallet or to limit its usage if we have reason to believe that the usage is unauthorized, fraudulent, or illegal. Misuse of the Bidding Karo Wallet or its benefits in any way may result in the Bidding Karo Wallet being disabled or its benefits being withdrawn at the sole discretion of Bidding Karo. Please ensure that you keep your Bidding Karo Wallet secure and safeguarded.",
    },
    {
      title: "14. Loading Value in Your Bidding Karo Wallet: ",
      text: "Loading Value in Your Bidding Karo Wallet: As soon as you accept these Terms and Conditions and register for Bidding Karo Platform’s services, the Bidding Karo Wallet is automatically created and enabled. To activate the wallet, you must load funds into it by visiting the Bidding Karo website or using the Bidding Karo mobile app. The Bidding Karo Wallet may be used as a payment method whenever a Bidding Karo Wallet holder buys goods or services from the Bidding Karo website or mobile app. The balance on the Bidding Karo Wallet does not have an expiration date.",
    },
    {
      title: "15. Bidding Karo reserves the right to change",
      text: "The minimum and maximum recharge amounts at any time by informing you during the recharge process or on the Bidding Karo website. Such modifications do not constitute an amendment to these Terms and Conditions. A Bidding Karo Wallet is not linked to a credit card, credit line, overdraft protection, or deposit account. Bidding Genie Private Limited will not accrue or pay any interest, dividends, or other earnings on funds deposited into a Bidding Karo Wallet.",
    },
    {
      title: "16. Bidding Karo Wallet",
      text: "The currency loaded onto your Bidding Karo Wallet are held and denominated in Indian Rupees.",
    },
    {
      title: "17. Registration and Liability for Unauthorized Transactions:",
      text: "You are responsible for all transactions made using your Bidding karo Wallet, including those claimed to be unauthorized. You’re Bidding karo Wallet does not have a separate authentication password or PIN and can be accessed for transactions once you log in to the platform, anyone with access to your account can access your application and use your Bidding karo Wallet. Therefore, you agree to take full responsibility for any unintended or unauthorized access to your Bidding karo Wallet.",
    },
    {
      title: "18. Blocking of Bidding karo Wallet:",
      text: "Bidding Genie Private Limited may block your Bidding karo Wallet and/or discontinue its use if we determine, at our sole discretion, that there have been fraudulent or unauthorized activities associated with your account. We reserve the right to take any actions necessary to protect our platform and our users from potential harm or damage.",
    },
    {
      title: "19. Privacy Statement:",
      text: "By accepting these Terms and Conditions, you give Bidding karo the right to disclose your information to government authorities, competent authorities, credit bureaus, and other third parties, as required by law. Bidding karo may also use your information to offer you products and services, including those from its associates or partners, unless you specify otherwise.",
    },
    {
      title: "20. Changes to these Terms and Conditions: ",
      text: "Bidding karo may modify the terms and conditions as well as the rules and regulations that apply to the Bidding karo Wallet without prior notice and without giving any reasons. the latest terms & conditions will be updated and viewed on our website www.Bidding karo.com.",
    },
    {
      title: "21. Disclaimers and Limits of Liability:  ",
      text: "Disclaimers and Limits of Liability: Bidding karo and its affiliates do not provide any express or implied representations, warranties or conditions related to the Bidding karo Wallet, including but not limited to, merchantability, fitness for a particular purpose, title, or non-infringement, or any warranty arising from trade usage, dealing or performance. Bidding karo does not guarantee that you’re Bidding karo Wallet will always be accessible or accepted.",
    },
    {
      title: "",
      text: "• If Bidding Karo or its affiliates are held liable to you, you are only entitled to recover actual and direct damages, which will not exceed the last balance held on your Bidding Karo Wallet. Bidding Karo and its affiliates will not be liable for any incidental, indirect or consequential damages (including, without limitation, loss of profit, revenue, or use) arising from or related to this Agreement, whether in contract, warranty, tort (including negligence, whether active, passive, or imputed), product liability, strict liability or other theory, even if Bidding Karo or its authorized representatives were informed of the possibility of such damages. Bidding Karo and its affiliates will not be liable for unauthorized access, alteration, theft, or destruction of your Bidding Karo Wallet due to accidental, fraudulent, or abusive means or devices by you or any third party, or as a result of any delay or mistake resulting from any circumstances beyond our control. Bidding Karo is not responsible for non-fulfilment of any terms in whole or in part due to any reason beyond our control.",
    },
    {
      title: "",
      text: "• Certain states or jurisdictions’ laws do not permit limitations on implied warranties, or the exclusion or limitation of certain damages. If these laws apply to you, some or all of the above disclaimers, exclusions or limitations may not apply to you, and you may have additional rights beyond those stated in this Terms and Conditions. In such jurisdictions, our liability is limited to the extent permitted by law.",
    },
    {
      title: "",
      text: "The decision of the management of Bidding karo is final and shall be always binding.",
    },
  ],
  [
    {
      title: "22. Confidentiality and Personal Data",
      text: "As you use our Services, you may receive information that is confidential (“Confidential Information”). You agree that during the term of this Agreement and for a period of 8 years after its termination:",
    },
    {
      title: "",
      text: "(a) Bidding Karo will remain the exclusive owner of all Confidential Information except for customer personal data owned by the respective customer.",
    },
    {
      title: "",
      text: "(b) You will use Confidential Information only as necessary for your participation in the Services and ensure that anyone who has access to Confidential Information is aware of and complies with these obligations.",
    },
    {
      title: "",
      text: "(c)  You will not disclose Confidential Information to any individual, company, or third party, including Affiliates, except as required by law.",
    },
    {
      title: "",
      text: "(d)  You will take reasonable measures to protect the Confidential Information from any use or disclosure that is not explicitly permitted in this Agreement.",
    },
    {
      title: "",
      text: "(e)  You will only retain Confidential Information for as long as it is necessary for participation in the Services or to fulfil your statutory obligations (e.g. tax) and delete such information upon termination or as soon as it is no longer required for statutory obligations.",
    },
    {
      title: "",
      text: "This Agreement does not restrict your right to share Confidential Information with a government entity that has jurisdiction over you, if you limit the disclosure to the minimum necessary and explicitly indicate the confidential nature of the shared information to the government entity.",
    },
    {
      title: "24. Force Majeure",
      text: "In the event of circumstances beyond our reasonable control, we shall not be held liable for any delay or failure to fulfil any of our obligations under this Agreement.",
    },
    {
      title: "25.  Suggestions and Other Information",
      text: "f you or any of your Affiliates choose to provide feedback, suggestions, ideas, improvements, or other materials to us in connection with or related to the Bidding karo Site or Services (including any related Technology), you hereby grant us a royalty-free, worldwide, and irrevocable license to use, modify, adapt, publish, translate, distribute, and display such materials for any purpose, without any obligation to compensate you or any third party. To comply with legal requirements, protect our systems and customers, or ensure the operation of our business and systems, we may access and disclose any information that we consider necessary or appropriate, such as user contact details, IP addresses, traffic information, usage history, and posted content.",
    },
    {
      title: "26.  Password Security",
      text: "If you use our platform, you are responsible for safeguarding the confidentiality of your password and for any activities that occur under your display name and password. You must not share your password with any third party unless they have been authorized by you to use your account in accordance with this agreement. You are solely responsible for any use or action taken under your password. If your password is compromised, you must immediately change it.",
    },
  ],
];

const TermsAndConditions = () => {
  useScrollToHash({ targetSection: "terms-conditions" });
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <br id="terms-conditions" />
      <Container maxWidth="lg" sx={{ mt: 10, mb: 4 }}>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{
            fontSize: "2.8rem",
            fontWeight: "bold",
            letterSpacing: "2px",
            textTransform: "uppercase",
          }}
        >
          <span style={{ color: "#062d72" }}>BIDDING</span>
          <span style={{ color: "#05baee" }}> KARO</span>
        </Typography>

        <Typography
          variant="h6"
          align="center"
          gutterBottom
          className={styles["heading-with-lines"]}
        >
          Terms and Conditions
        </Typography>

        <Box sx={{ p: 3 }}>
          {termsContent[page - 1].map((item, index) => (
            <Typography
              key={index}
              variant="body1"
              sx={{ textAlign: "justify", mb: 2 }}
            >
              <strong>{item.title}</strong> {item.text}
            </Typography>
          ))}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3
          }}>
          <Pagination
            count={termsContent.length}
            page={page}
            onChange={handleChange}
            sx={{
              "& .MuiPaginationItem-root": {
                color: "#062d72 ", // Text color
                borderColor: "#062d72 !important", // Border color
              },
              "& .Mui-selected": {
                backgroundColor: "#062d72 !important", // Active page background
                color: "white", // Active page text
              },
              "& .MuiPaginationItem-root:hover": {
                backgroundColor: "#9babc6 !important", // Hover effect
              },
            }}
          />
        </Box>
      </Container>
    </>
  );
};

export default TermsAndConditions;
